import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { PopupLayoutComponent } from "./popup-layout.component";
import { ConfirmationPopupComponent } from "../confirmation-popup.component";
import { CreditLimitPopupComponent } from "app/admin/dashboard-cards/credit-limit-popup/credit-limit-popup.component";
import { CreateMandateDebitComponent } from "app/admin/card-accounts-settings/usage-settings/usage-settings-mandate/mandate-debit-tab/create-mandate-debit/create-mandate-debit.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { SharedModule } from "app/modules/shared/shared.module";
import { OtpModalComponent } from "app/modules/shared/components/otp-modal/otp-modal.component";
import { EnachWorkingFlowPopupComponent } from "app/admin/create-mandate/enach-working-flow-popup/enach-working-flow-popup.component";

import { TenantSelectionPopupComponent } from "app/home/tenant-selection-popup/tenant-selection-popup.component";

import { BlockCardConfirmPopupComponent } from "app/admin/dashboard-cards/block-card-confirm-popup/block-card-confirm-popup.component";
import { MessagePopupComponent } from "./message-popup/message-popup.component";
import { OpenVouchersSuccessPopupComponent } from "app/admin/open-vouchers-success-popup/open-vouchers-success-popup.component";
import { OpenVouchersFailurePopupComponent } from "app/admin/open-vouchers-failure-popup/open-vouchers-failure-popup.component";
import { RedeemRewardsSuccessPopupComponent } from "app/public/signup/redeem-rewards-success-popup/redeem-rewards-success-popup.component";
import { RedeemRewardsFailurePopupComponent } from "app/public/signup/redeem-rewards-failure-popup/redeem-rewards-failure-popup.component";
import { RedeemRewardsPopupComponent } from "app/public/signup/redeem-rewards-popup/redeem-rewards-popup.component";
import { VkycCardComponent } from "app/card-holder/view-card/vkyc-card/vkyc-card.component";
import { RequestDemoPopupComponent } from "@app/public/signup/request-demo-popup/request-demo-popup.component";
import { CreateAccountPopupComponent } from "@app/public/signup/create-account-popup/create-account-popup.component";
import { TenantSwitchOtpPopupComponent } from "app/home/tenant-switch-otp-popup/tenant-switch-otp-popup.component";
import { FaudEngineAddRuleComponent } from "@app/system-admin/faud-engine/faud-engine-add-rule/faud-engine-add-rule.component";
import { AccountsStepperPopupComponent } from "@app/public/signup/accounts-stepper-popup/accounts-stepper-popup.component";
import { AddFundPopupComponent } from "@app/public/signup/add-fund-popup/add-fund-popup.component";
import { VirtualAccountTransferPopupComponent } from "@app/admin/dashboard-cards/virtual-account-transfer-popup/virtual-account-transfer-popup.component";
import { InputAmountFieldModule } from "@app-module/shared/input-amount-field/input-amount-field.module";
import { MealCardInfoComponent } from "@app/home/meal-card-info/meal-card-info.component";
import { NotifiedPopupComponent } from "@app/home/notified-popup/notified-popup.component";
import { GenericContactDetailsComponent } from "@app/home/generic-contact-details/generic-contact-details.component";
import { CreatePrepaidAccountPopupComponent } from "@app/home/create-prepaid-account-popup/create-prepaid-account-popup.component";
import { MealCardPopupComponent } from "@app/home/meal-card-popup/meal-card-popup.component";
import { MealCardEmployeeInfoComponent } from "@app/home/meal-card-employee-info/meal-card-employee-info.component";
import { CloseButtonModule } from "@app-module/shared/close-button/close-button.module";
import { ReferCompanyPopupComponent } from "@app/public/signup/refer-company-popup/refer-company-popup.component";
import { EmailInputPopupComponent } from "@app/home/email-input-popup/email-input-popup.component";
import { OtpCardDetailsComponent } from "@app/card-holder/card-details/otp-card-details/otp-card-details.component";
import { EditCardDetailsPopupComponent } from "@app/card-holder/card-details/edit-card-details-popup/edit-card-details-popup.component";
import { CardDetailsActionButtonConfirmPopupComponent } from "@app/card-holder/card-details/card-details-header/card-details-button-action/card-details-action-button-confirm-popup/card-details-action-button-confirm-popup.component";
import { WhatsappSharePopupComponent } from "@app/home/whatsapp-share-popup/whatsapp-share-popup.component";
import { FreedomDailogComponent } from "@app/home/freedom-dialog/freedom-dailog.component";
import { PettyCashPopupComponent } from "@app/home/petty-cash/petty-cash-popup.component";
import { PCGenericContactDetailsComponent } from "@app/home/petty-cash/generic-contact-details/pc-generic-contact-details.component";
import { CreatePettyCashAccountPopupComponent } from "@app/home/petty-cash/create-petty-cash-account-popup/create-petty-cash-account-popup.component";
import { PettyCashInfoComponent } from "@app/home/petty-cash/petty-cash-info/petty-cash-info.component";
import { PettyCashEmployeeInfoComponent } from "@app/home/petty-cash/petty-cash-employee-info/petty-cash-employee-info.component";
import { AllocateFundsCardsComponent } from "@app/card-holder/card-details/card-details-header/card-details-button-action/allocate-funds-cards/allocate-funds-cards.component";
import { UnAllocateFundsCardsComponent } from "@app/card-holder/card-details/card-details-header/card-details-button-action/un-allocate-funds-cards/un-allocate-funds-cards.component";
import { ExpenseMarketingModelComponent } from "@app-module/shared/components/enkash-toolbar/expense-marketing-model/expense-marketing-model.component";
import { VoucherMarketingModelComponentComponent } from "@app-module/shared/components/enkash-toolbar/voucher-marketing-model-component/voucher-marketing-model-component.component";
import { VoucherNotificationNudge } from "@app-module/shared/components/enkash-toolbar/voucher-notification-nudge/voucher-notification-nudge.component";
import { ExpenseNotificationNudge } from "@app-module/shared/components/enkash-toolbar/expense-notification-nudge/expense-notification-nudge.component";

import { CompleteKycModalComponent } from "@app/seamlessbanking/complete-kyc-modal/complete-kyc-modal.component";
import { ThanksModalComponent } from "@app/seamlessbanking/thanks-modal/thanks-modal.component";
import { CongratsSeamlessModalComponent } from "@app/seamlessbanking/congrats-seamless-modal/congrats-seamless-modal.component";
import { PDCAddCardFailedComponent } from "@app/platform-debit-card/add-card/add-card-failed-modal/add-card-failed-modal.component";
import { TncUnallocateAcceptDialog } from "@app-module/shared/dialogs/TncUnallocate/tnc-unallocate.dialog.component";
import { ChannelIncentiveNotificationNudge } from "@app-module/shared/components/enkash-toolbar/channel-incentive-notification-nudge/channel-incentive-notification-nudge.component";
import { EmployeeRewardsNotificationNudge } from "@app-module/shared/components/enkash-toolbar/employee-rewards-notification-nudge copy/employee-rewards-notification-nudge.component";
import { OtpPopupComponent } from "@app/seamlessbanking/connect-banking-otp-popup/connect-banking-otp-popup.component";
import { BankAccountTransferPopupComponent } from "@app/admin/dashboard-cards/bank-account-transfer-popup/bank-account-transfer-popup.component";
import { GenericOtpModalComponent } from "@app-module/shared/components/generic-otp-modal/generic-otp-modal.component";
import { FeedbackPopup } from "@app-module/shared/components/enkash-toolbar/feedback-popup/feedback-popup.component";
import { CreateOutstandingPopupComponent } from "@app/system-admin/outstanding/create-outstanding-popup/create-outstanding-popup.component";
// import { ViewHistoryComponent } from "@app/system-admin/outstanding/view-history/view-history.component";
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { ReferEnkashCoinsPopupComponent } from "@app/home/refer-enkash-coins-popup/refer-enkash-coins-popup.component";
import { TripDetailsComponent } from "@app/expense-management/components/trip/trip-details/trip-details.component";
import { ErupiPopupComponent } from "@app/card-holder/erupi-account/erupi-popup.component";
import { ErupiInfoComponent } from "@app/card-holder/erupi-account/erupi-info/erupi-info.component";
import { CreateErupiPopupComponent } from "@app/card-holder/erupi-account/create-erupi-account-popup/create-erupi-popup.component";
import { ErupiGenericContactDetailsComponent } from "@app/card-holder/erupi-account/generic-contact-details/erupi-generic-contact-details.component";
import { ErupiEmployeeInfoComponent } from "@app/card-holder/erupi-account/erupi-employee-info/erupi-employee-info.component";
import { HelpErupiPopupComponent } from "@app/admin/dashboard-cards/erupi/help-erupi/helpErupi-popup.component";
import { ManualExpenseRestrictionPopup } from "@app-module/shared/components/enkash-toolbar/manual-expense-restriction-popup/manual-expense-restriction-popup.component";
@NgModule({
  declarations: [
    PopupLayoutComponent,
    ConfirmationPopupComponent,
    CreditLimitPopupComponent,
    CreateOutstandingPopupComponent,
    CreateMandateDebitComponent,
    // ViewHistoryComponent,
    OtpModalComponent,
    EnachWorkingFlowPopupComponent,
    TenantSelectionPopupComponent,
    TenantSwitchOtpPopupComponent,
    BlockCardConfirmPopupComponent,
    MessagePopupComponent,
    OpenVouchersSuccessPopupComponent,
    ExpenseMarketingModelComponent,
    VoucherMarketingModelComponentComponent,
    VoucherNotificationNudge,
    ExpenseNotificationNudge,
    FeedbackPopup,
    ChannelIncentiveNotificationNudge,
    EmployeeRewardsNotificationNudge,
    ManualExpenseRestrictionPopup,
    OpenVouchersFailurePopupComponent,
    RedeemRewardsSuccessPopupComponent,
    RedeemRewardsFailurePopupComponent,
    RedeemRewardsPopupComponent,
    VkycCardComponent,
    TncUnallocateAcceptDialog,
    RequestDemoPopupComponent,
    CreateAccountPopupComponent,
    FaudEngineAddRuleComponent,
    AccountsStepperPopupComponent,
    AddFundPopupComponent,
    FaudEngineAddRuleComponent,
    VirtualAccountTransferPopupComponent,
    MealCardInfoComponent,
    NotifiedPopupComponent,
    GenericContactDetailsComponent,
    PCGenericContactDetailsComponent,
    CreatePrepaidAccountPopupComponent,
    CreatePettyCashAccountPopupComponent,
    PettyCashInfoComponent,
    ErupiEmployeeInfoComponent,
    HelpErupiPopupComponent,
    ErupiGenericContactDetailsComponent,
    MealCardPopupComponent,
    MealCardEmployeeInfoComponent,
    PettyCashEmployeeInfoComponent,
    ReferCompanyPopupComponent,
    EmailInputPopupComponent,
    OtpCardDetailsComponent,
    UnAllocateFundsCardsComponent,
    AllocateFundsCardsComponent,
    EditCardDetailsPopupComponent,
    CardDetailsActionButtonConfirmPopupComponent,
    WhatsappSharePopupComponent,
    FreedomDailogComponent,
    PettyCashPopupComponent,
    CreateErupiPopupComponent,
    ErupiInfoComponent,
    ErupiPopupComponent,
    CompleteKycModalComponent,
    ThanksModalComponent,
    CongratsSeamlessModalComponent,
    PDCAddCardFailedComponent,
    OtpPopupComponent,
    GenericOtpModalComponent,
    BankAccountTransferPopupComponent,
    ReferEnkashCoinsPopupComponent,
    TripDetailsComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    InputAmountFieldModule,
    CloseButtonModule,
    InfiniteScrollModule,
  ],
  exports: [PopupLayoutComponent]
})
export class PopupLayoutModule { }
